import {BaseModel} from "@/models/base/BaseModel";

export class MaintenanceType extends BaseModel {
  name: string;
  categoryId: string;
  category: string;
  icon: string;
  department: string;

  constructor() {
    super()
    this.name = "";
    this.categoryId = "";
    this.category = "";
    this.icon = "";
    this.department = "";
  }
}